<template>
  <div>
    <v-toolbar>
      <v-container fluid>
        <div class="d-flex align-center">
          <back />
          <h3 class="ml-5 primary--text d-flex">
            <span class="mr-2">
              {{ countryName }}
            </span>
            <!--            <portal-target-->
            <!--              tag="span"-->
            <!--              name="countryAdministrationHeaderLeftSide"-->
            <!--            >-->
            <!--            </portal-target>-->
          </h3>
          <v-spacer />
          <portal-target name="countryAdministrationHeaderRightSide" />
        </div>
      </v-container>
    </v-toolbar>

    <v-container
      class="mt-5"
      fluid
    >
      <router-view />
    </v-container>
  </div>
</template>

<script>
    import Back from "@/components/atoms/Back";

    import Me from "@/mixins/Me";
    import Country from "@/mixins/Country";

    export default {
        name: "CountryAdministrationBase",
        components: {
            Back
        },

        mixins: [
            Me,
            Country
        ],

        computed: {
            countryName() {
                return this.country?.name || ''
            }
        },

        created() {
            // TODO check access
            if (!this.$route.params.countryId) {
                if (this.meCountry.id) {
                    this.$router.replace({name: 'CountryAdministrationView', params: {countryId: this.meCountry.id}})
                } else {
                    this.$router.replace({name: 'Home'})
                }
            }
            // console.log("this.$route: ", this.$route);
            // console.log("this.$router: ", this.$router);

        },

        destroyed() {
            this.$store.commit('laboratories/reset');
        },
    }
</script>

<style scoped>

</style>
